<template>
  <span
    class="ocr-sk-line"
    :class="{
      'ocr-sk-line--pill': pill,
      'ocr-sk-line--round': round,
      'ocr-sk-line--inline': !block,
      'ocr-sk-line--block': block,
    }"
    :style="lineStyle"
  />
</template>

<script>
export default {
  name: "OcrSkLine",
  props: {
    width: { type: String, default: "100%" },
    height: { type: String, default: "12px" },
    maxWidth: { type: String, default: "" },
    pill: { type: Boolean, default: false },
    round: { type: Boolean, default: false },
    block: { type: Boolean, default: true },
  },
  computed: {
    lineStyle() {
      const style = { width: this.width, height: this.height };
      if (this.maxWidth) style.maxWidth = this.maxWidth;
      return style;
    },
  },
};
</script>
